import React, { useState, useRef, useEffect, memo } from "react";

const keyActions = {
  ArrowRight: (index, last) => (index === last ? 0 : index + 1),
  ArrowLeft: (index, last) => (index === 0 ? last : index - 1),
  Home: () => 0,
  End: (_index, last) => last,
};

const AccessibleTabs = ({
  tabs,
  defaultActive,
  panelWrapperClass = "",
  panelClassMap = {},
}) => {
  const [activeScreen, setActiveScreen] = useState(defaultActive);
  const tabRefs = useRef([]);

  const handleKeyDown = (e, index) => {
    const action = keyActions[e.key];
    if (!action) return;

    e.preventDefault();
    const lastIndex = tabs.length - 1;
    const newIndex = action(index, lastIndex);

    setActiveScreen(tabs[newIndex].id);
    tabRefs.current[newIndex]?.focus();
  };

  useEffect(() => {
    tabRefs.current[0]?.focus();
  }, []);

  return (
    <>
      {/* TAB LIST */}
      <div className="menu_bar tabMenu_bar">
        <ul role="tablist">
          {tabs.map((tab, index) => (
            <li key={tab.id} role="none">
              <button
                id={`tab-${tab.id}`}
                role="tab"
                aria-selected={activeScreen === tab.id}
                aria-controls={`tabpanel-${tab.id}`}
                ref={(el) => (tabRefs.current[index] = el)}
                className={activeScreen === tab.id ? "active" : ""}
                tabIndex={activeScreen === tab.id ? 0 : -1}
                onClick={() => setActiveScreen(tab.id)}
                onKeyDown={(e) => handleKeyDown(e, index)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* TAB PANELS */}
      {tabs.map((tab) => {
        const Component = tab.Component;

        return (
          <div
            key={tab.id}
            id={`tabpanel-${tab.id}`}
            role="tabpanel"
            aria-labelledby={`tab-${tab.id}`}
            hidden={activeScreen !== tab.id}
            tabIndex={-1}
            className={`${panelWrapperClass} ${
              panelClassMap[tab.id] || ""
            }`}
          >
            {activeScreen === tab.id && <Component />}
          </div>
        );
      })}
    </>
  );
};

export default memo(AccessibleTabs);